// assets/collection-desc-toggle.js
(() => {
  const SELECTOR_WRAPPER = '.collection-desc-wrapper';
  const SELECTOR_DESC    = '.collection-desc';
  const SELECTOR_TOGGLE  = '.collection-desc-toggle';

  // Petit utilitaire pour exécuter après la 1re peinture
  const afterPaint = (fn) => requestAnimationFrame(() => requestAnimationFrame(fn));

  // Init d’un wrapper (idempotent)
  function initWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.cdInit === '1') return;
    const desc   = wrapper.querySelector(SELECTOR_DESC);
    const toggle = wrapper.querySelector(SELECTOR_TOGGLE);
    if (!desc || !toggle) return;

    // Flag d’init pour éviter les doublons
    wrapper.dataset.cdInit = '1';

    // Afficher le bouton seulement si ça déborde (après paint pour ne pas impacter LCP)
    afterPaint(() => {
      const needs = desc.scrollHeight > desc.clientHeight + 1;
      toggle.hidden = !needs;
      if (!needs) {
        desc.classList.remove('expanded');
        toggle.textContent = 'Voir plus';
      }
    });
  }

  // Scan initial
  function scanAll(root = document) {
    root.querySelectorAll(SELECTOR_WRAPPER).forEach(initWrapper);
  }

  // Event délégué (pas besoin de rebind après AJAX)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTOR_TOGGLE);
    if (!btn) return;
    const wrapper = btn.closest(SELECTOR_WRAPPER);
    const desc = wrapper?.querySelector(SELECTOR_DESC);
    if (!desc) return;

    const open = !desc.classList.contains('expanded');
    desc.classList.toggle('expanded', open);
    btn.textContent = open ? 'Voir moins' : 'Voir plus';

    // Si on referme et que Firefox a des restes de hauteur, on force un reflow léger
    if (!open) void desc.offsetHeight;
  }, { passive: true });

  // Observer d’insertion DOM (AJAX, Section Rendering, PJAX…)
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.type !== 'childList' || (!m.addedNodes || !m.addedNodes.length)) continue;
      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.(SELECTOR_WRAPPER)) initWrapper(node);
        else scanAll(node);
      });
    }
  });

  // Boot
  document.addEventListener('DOMContentLoaded', () => {
    scanAll(document);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  });

  // Événements Shopify (éditeur de thème)
  document.addEventListener('shopify:section:load', (e) => scanAll(e.target));
  document.addEventListener('shopify:section:select', (e) => scanAll(e.target));
  document.addEventListener('shopify:section:reorder', (e) => scanAll(e.target));

  // Si ton thème émet un event custom après render AJAX, branche-le ici
  // document.addEventListener('sections:reloaded', () => scanAll(document));
})();
